// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//IMG

const BannerVendi: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="bannerValuta" className="space-ptb bg-primary">
      <div className="container-fluid w-80">
        <p className="mb-2 sub-title" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.subTitle') as string }} />
        <h2 className="mb-3">{t('homePage.sellBanner.title')}</h2>
        <div className="row align-items-center">
          <div className="col-12 col-lg-9 col-xl">
            <p className="mb-4 mb-lg-0" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
          </div>
          <div className="col-12 col-lg-3 col-xl-auto">
            <Link className="btn btn-primary" to="/valutazione">
              <span>{t('homePage.sellBanner.btnText')}</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerVendi;